export default {"src":"/_next/static/media/medical-services-icon.72adde89.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};